<template> 
    <button class="btn btn-sm btn-secondary border border-pmes-warning me-3" btn-set-rota data-bs-toggle="modal" :data-bs-target="'#' + modal " @click="iniciar" >  
        <span class="menu-icon">
            <i class="fas text-pmes-warning fa-edit fa-2x bi fs-2x" ></i> 
        </span> Editar  
    </button> 
    <div class="modal fade" :id="modal" tabindex="-1" aria-hidden="true"  >  
        <div class="modal-dialog" style="max-width:1700px;">  
            <div class="modal-content" >  
                <div class="modal-header"> 
					<h2>Editar Matricula</h2> 
					<div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" >
						<span class="svg-icon svg-icon-1">
							<inline-svg src="media/icons/duotone/Navigation/Close.svg" />
						</span>
					</div> 
				</div> 
				<div class="modal-body scroll-y " :key="identificador" v-if="matricula"> 
                    <div class="row g-6 g-xl-12 min-h-1350px mb-10" v-if="matricula.status.id != 6">   
                        <div class="col-12 col-sm-6 col-lg-6"  > 
                            <div class="form-group"> 
                                <label for="pelotao" class="form-check-label">Pelotão:</label>   
                                <input required type="number"  name="pelotao" class="form-control" v-model="pelotao"  >  
                            </div>
                        </div>  
                        <div class="col-12 col-sm-6 col-lg-6" > 
                            <div class="form-group"> 
                                <label for="numeroCurso" class="form-check-label">Número Curso:</label>   
                                <input required type="number"  name="numeroCurso" class="form-control" v-model="numeroCurso"  >  
                            </div>
                        </div>  
                        <div class="col-12 col-sm-12"  > 
                            <div class="form-group"> 
                                <label for="processoLiminar" class="form-check-label">Número Processo (Liminar):</label>   
                                <input required type="text"  name="processoLiminar" class="form-control" v-model="processoLiminar"  >  
                            </div>
                        </div>  

                        <div class="col-12 col-sm-6 col-lg-3" > 
                            <div class="form-group"> 
                                <input  class="form-contro form-check-input" type="checkbox" v-model="isPendAcadSaude" name="isPendAcadSaude"> 
                                <label class="form-check-label mx-2" for="isPendAcadSaude">Pendencia Academica Saúde</label> 
                            </div>
                        </div>  
                        <div class="col-12 col-sm-6 col-lg-3" > 
                            <div class="form-group"> 
                                <input  class="form-contro form-check-input" type="checkbox" v-model="isPendAcadProc" name="isPendAcadProc"> 
                                <label class="form-check-label mx-2" for="isPendAcadProc">Pendencia Academica Procedimento</label>   
                            </div>
                        </div>  
                        <div class="col-12 col-sm-6 col-lg-3" > 
                            <div class="form-group"> 
                                <input  class="form-contro form-check-input" type="checkbox" v-model="isLiminar" name="isLiminar"> 
                                <label class="form-check-label mx-2" for="isLiminar">Liminar</label>   
                            </div>
                        </div>  
                        <div class="col-12 col-sm-6 col-lg-3" > 
                            <div class="form-group"> 
                                <input  class="form-contro form-check-input" type="checkbox" v-model="isRemanescente" name="isRemanescente"> 
                                <label class="form-check-label mx-2" for="isRemanescente">Remanescente</label>   
                            </div>
                        </div>  


                        <div class="col-12 col-sm-12 col-lg-12" v-if="matricula.isLiminar != isLiminar || matricula.isPendAcadSaude != isPendAcadSaude || matricula.isPendAcadProc != isPendAcadProc"> 
                            <div class="form-group"> 
                                <label for="observacao" class="form-check-label">Observação:</label>   
                                <input required type="text"  name="observacao" class="form-control" v-model="observacao"  >  
                            </div>
                        </div>  
                        
                    </div> 
                    <div class="row g-6 g-xl-12 min-h-1350px mb-10" v-if="matricula.status.id == 6">   
                        <div class="col-12 col-sm-6 col-lg-6"  > 
                            <div class="form-group"> 
                                <label for="dataPublicacao" class="form-check-label">Data da publicação:</label>   
                                <input required type="date"  name="dataPublicacao" class="form-control" v-model="dataPublicacao"  >  
                            </div>
                        </div>  
                        <div class="col-12 col-sm-6 col-lg-6" > 
                            <div class="form-group"> 
                                <label for="docPublicacao" class="form-check-label">Documento da Publicação:</label>   
                                <input required type="text"  name="docPublicacao" class="form-control" v-model="docPublicacao"  >  
                            </div>
                        </div>  
                        <div class="col-12 col-sm-6 col-lg-6"  > 
                            <div class="form-group"> 
                                <label for="dataAprovado" class="form-check-label">Data da Aprovação:</label>   
                                <input required type="date"  name="dataAprovado" class="form-control" v-model="dataAprovado"  >  
                            </div>
                        </div>  
                        <div class="col-12 col-sm-6 col-lg-6" > 
                            <div class="form-group"> 
                                <label for="mediaFinal" class="form-check-label">Média Final:</label>   
                                <input required type="number"  name="mediaFinal" class="form-control" v-model="mediaFinal"   step="0.0001" min="0" max="10">  
                            </div>
                        </div>  
                    </div>  
                    <br>
                    <div class="modal-footer"  > 
                        <BotaoSalvar  @click="AlterarMatricula" :processando="processando" ></BotaoSalvar>   
                    </div>  
				</div>   
			</div> 
		</div> 
	</div> 
</template>

<script lang="ts">   
    import { PerfilConfig } from "@/core/config/PerfisConfig"; 
    import   SiteUtils   from '@/assets/ts/aplicacao/site'; 
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
	import $ from "jquery"  
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options , Vue } from "vue-class-component";   
    import {  Prop  , Watch } from 'vue-property-decorator';   
    @Options({
        name: "EditarMatricula",
        components: {  CardRh, BotaoSalvar },   
        emits: [  'dados-matricula-alterado'],  

    }) 
    export default class EditarMatricula extends Vue { 
        
        @Prop( ) readonly matricula!: any  
        @Prop( ) readonly service!: any   
        @Prop( ) readonly perfis!: any  
        
        public identificador = 1 ;   
        public numeroCurso: any = null ; 
        public isPendAcadSaude: any = null ; 
        public isLiminar: any = null ; 
        public isPendAcadProc: any = null ; 
        public isRemanescente: any = null ; 
        public pelotao: any = null ;
        public processoLiminar: any = null ;
        public dataAprovado: any = null ;
        public docPublicacao: any = null ;
        public dataPublicacao: any = null ;
        public mediaFinal: any = null ; 
        public observacao: any = null ; 
        public modal: any = "modal_matricula_editar" ;
        public processando = false ;

        @Watch('matricula')
		dadosAtualizado(newVal: string) { 
            this.identificador++; 
		} 
         
        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }
  
        public iniciar() { 
            this.processoLiminar = this.matricula.processoLiminar; 
            this.pelotao = this.matricula.pelotao; 
            this.numeroCurso = this.matricula.numeroCurso;  
            this.isPendAcadSaude = this.matricula.isPendAcadSaude;  
            this.isLiminar = this.matricula.isLiminar;  
            this.isPendAcadProc = this.matricula.isPendAcadProc;  
            this.isRemanescente = this.matricula.isRemanescente;  
            this.mediaFinal = this.matricula.mediaFinal; 
            this.dataAprovado = SiteUtils.formatDataToPadrao( this.matricula.dataAprovado ); 
            this.docPublicacao = this.matricula.docPublicacao; 
            this.dataPublicacao =  SiteUtils.formatDataToPadrao(this.matricula.dataPublicacao); 
            this.identificador++; 
        }

        
        public AlterarMatricula() {
            if( this.processando  ||  !this.hasPermissao ){
                return;
            }
            this.processando = true ;
            let dados: any = {};
            if(this.matricula.status.id == 6){
                dados = {
                    id: this.matricula.id,
                    mediaFinal: this.mediaFinal,
                    dataAprovado: this.dataAprovado,
                    docPublicacao: this.docPublicacao,
                    dataPublicacao: this.dataPublicacao,
                }
            } 
            else{
                dados = {
                    id: this.matricula.id,
                    pelotao: this.pelotao,
                    processoLiminar: this.processoLiminar,
                    numeroCurso: this.numeroCurso, 
                    isPendAcadSaude: this.isPendAcadSaude, 
                    isLiminar: this.isLiminar, 
                    isPendAcadProc: this.isPendAcadProc,  
                    isRemanescente: this.isRemanescente,  
                }
                if( this.matricula.isLiminar != this.isLiminar || this.matricula.isPendAcadSaude != this.isPendAcadSaude || this.matricula.isPendAcadProc != this.isPendAcadProc){
                    dados.observacao = this.observacao
                }
            } 
            this.service.alterarSimples( this.matricula.id , dados )
            .then(response => { 
                this.$emit("dados-matricula-alterado", response);
                this.processando = false ;
                $("[data-bs-dismiss='modal']").trigger({ type: "click" });
            })
            .catch(errors => {
                this.processando = false ;
            });
        }


    } 
</script> 


<style scoped>  
    .btn-flex-full{
        max-width: 100%;
        min-width: 100%;
    } 
    .start-90{
        left: 97% !important;
    }
</style>